<template>
  <section
    class="row"
    :class="[backgroundColorClass, hasOverflowHidden ? 'has-overflow-hidden' : null]"
  >
    <slot />
  </section>
</template>

<script>
export default {
  name: 'KfRow',
  props: {
    backgroundColor: {
      type: String,
      default: null,
    },
    hasOverflowHidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    backgroundColorClass() {
      return this.backgroundColor
        ? `has-color-${this.backgroundColor.toLowerCase().replace(' ', '-')}`
        : null;
    },
  },
};
</script>

<style lang="postcss">
.row {
  @apply relative overflow-visible;

  &.has-color-gray {
    @apply bg-gray-50;
  }

  &.has-overflow-hidden {
    @apply overflow-hidden;
  }
}
</style>
